import { Options, Vue } from "vue-class-component";
import { Authentication } from '../../modules/authentication/authentication';
import { AuthorizedUser } from '../../models/authorized-user';
import { SELF_URL } from '../../config/config';
import { Url } from '../../config/url';
import store from '../../store';
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";
import StdPageLayout from "../std-page-layout/index.vue";
@Options({
  components: {
    StdPageLayout,
    LoadingSpinner
  }
})
export default class Logout extends Vue {

  private authentication: Authentication = new Authentication(
    this.userAccount);

  created() {
    this.authentication.logout(this.logoutCallBack);
  }

  private logoutCallBack(): void {
    setTimeout( () => { document.location.href = SELF_URL + Url.Logout; }, 0);
  }

  get userAccount(): AuthorizedUser {
    return store.getters.getUserAccount;
  }
}
